import {
  CHANGE_ACTIVE_TS_EXPERT,
  CHANGE_ACTIVE_ITEM_LIVELIST,
  CHANGE_ACTIVE_ITEM_TOPOLOGY,
  CHANGE_ACTIVE_ITEM_TRAFFIC,
  CHANGE_ACTIVE_ITEM_LOG,
  CHANGE_ACTIVE_ITEM_CONFIG,
  CHANGE_ACTIVE_ITEM_INVENTORY,
  SOLVE_PROBLEM,
} from "../actions/types";

export function activeMenuItemReducer(initialState = { activeItem: "/" }, action) {
  switch (action.type) {
    case CHANGE_ACTIVE_TS_EXPERT:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_LIVELIST:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_INVENTORY:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_TOPOLOGY:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_TRAFFIC:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_LOG:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_CONFIG:
      return action.payload.activeItem;
    default:
      return initialState;
  }
}

export function solveProblemReducer(initialState = { solve: false, problem: {} }, action) {
  switch (action.type) {
    case SOLVE_PROBLEM:
      return action.payload;
    default:
      return initialState;
  }
}